// extracted by mini-css-extract-plugin
export var answers = "uwdOR";
export var body = "QH1by";
export var icon = "DFZrX";
export var intro = "SAP-I";
export var item = "IHSDW";
export var main = "yTfeR";
export var title = "xMYdo";
export var toggle = "m9qTo";